// TODO: split it into separate files

export enum FeedVisibility {
  User = 'My Posts',
  Team = 'Team Posts',
  All = 'All Posts',
}

export type AgentIntelActivitySearchParamsType = {
  searchText?: string;
  fromDate?: string;
  toDate?: string;
  agentIds?: number[];
  clientIds?: number[];
  page: number;
  pageSize: number;
  tags?: string[];
  cursor?: number;
  limit?: number;
  direction?: 'before' | 'after';
  locations?: {
    State?: string;
    City?: string;
  }[];
};

export type AgentIntelFiltersType = {
  keyword: string;
  locations: {
    location: any;
    active: boolean;
  }[];
  dateRange: {
    from?: Date;
    to?: Date;
  };
  tags: { value: number; label: string; active?: boolean }[];
  agents: { value: number; label: string; active?: boolean }[];
};

export type PreparedAgentIntelActivityDataType = {
  id: number;
  user: {
    name: string;
    role: string;
    avatar: string;
  };
  createdAt: string;
  title: string;
  description: string;
  images: string[];
  mediaLink: string | undefined;
  isNew?: boolean;
  publishedTo:
    | 'ALL'
    | {
        type: 'CLIENT' | 'AREA';
        data: string[];
      };
};
